import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import API from "../../Api/Api";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";

function areEqual(prevProps, nextProps) {
  let a = prevProps.processes, b = nextProps.processes;
  if (a.length !== b.length) return false;

  return true;
}

export default React.memo(function ProcessSelectTable(props) {

  const api = new API();

  const process_columns = [
    {title: "Name", field: "name"},
    // {title: "Description", field: "description"},
  ];

  const [processes, setProcesses] = useState([]);
  useEffect(() => {
    api.getProcessAPI().listProcesses(props.haccpPlanPk).then(response => {
      let processesAvailable = [...response.data];

      let processesSelected = props.processes.map(process => {
        return process.pk;
      });

      let filteredProcesses = processesAvailable.filter(process => {
        return !processesSelected.includes(process.pk);
      });

      setProcesses(filteredProcesses);
    });
  }, [props.processes]);

  const handleDelete = (process) => {
    props.removeProcess(process);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        {props.processes.map(process => {
          return (
            <Chip style={{margin: '4px'}}
                  variant="outlined"
                  color="primary"
                  key={process.pk}
                  label={process.name}
                  onDelete={() => {
                    handleDelete(process);
                  }}
            />
          )
        })}
      </Grid>
      <Grid item xs={12}>
        <MaterialTable
          title="Processes"
          columns={process_columns}
          data={processes}

          components={{
            Container: props => <Paper {...props} elevation={0}/>
          }}

          options={{
            selection: false,
          }}

          actions={[
            {
              icon: 'add',
              tooltip: 'Add to Hazard',
              onClick: (event, rowData) => props.addProcess(rowData)
            }
          ]}
        />
      </Grid>
    </Grid>
  )
}, areEqual)